<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs12>
        <v-card>

          <!-- Título da tela -->
          <basic-toolbar :title="'Meus Projetos de Pesquisa'"></basic-toolbar>

          <v-card-title>
            
            <v-spacer></v-spacer>

            <!-- Filtro de resultados -->
            <v-text-field append-icon="filter_list" label="Filtrar resultados" v-model="search"></v-text-field>

          </v-card-title>

          <!-- Tabela com os projetos do usuário logado -->
          <v-data-table
            :headers="headers"
            :items="listaMeusProjetosPesquisa"
            :search="search"
            :no-data-text="'Você não participa de nenhum projeto de pesquisa'"
            must-sort
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :items-per-page="itemsPerPage"
            :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
          >
            <!-- Ícones da coluna "Opções" -->
            <template v-slot:item.opcoes="props">

              <!-- Ícone para visualizar o cadastro do projeto -->
              <c-tooltip-btn
              icon="library_books"
              color="primary"
              tooltip="Visualizar cadastro do projeto"
              @click="toAbrirCadastroProjetoPesquisa(props.item.id)"
              ></c-tooltip-btn>

            </template>

            <!-- Formata o número de registro -->
            <template v-slot:item.numRegistro="props">{{props.item.numRegistro === null || props.item.numRegistro === '' ? '-' : props.item.numRegistro}}</template>

            <!-- Formata a sigla -->
            <template v-slot:item.sigla="props">{{props.item.sigla === null || props.item.sigla === '' ? '-' : props.item.sigla}}</template>

            <!-- Formata a data de início -->
            <template v-slot:item.dataInicio="props">{{dates.format(props.item.dataInicio)}}</template>

            <!-- Número total de projetos -->
            <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
              Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaMeusProjetosPesquisa.length }} {{ listaMeusProjetosPesquisa.length > 1 ? 'projetos' : 'projeto' }}
            </template>
            
          </v-data-table>

        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import TootipButton from '@/components/c-tooltip-btn'
import dates from '@/utils/dates'
import projetos from '@/utils/projetos'
import { mapActions } from 'vuex'

export default {
  data: () => ({
    dates: dates,
    search: null,
    sortBy: 'id',
    sortDesc: true,
    itemsPerPage: 25,
    opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
    headers: [
      { text: 'Nº Registro', align: 'left', value: 'numRegistro' },
      { text: 'Título', align: 'left', value: 'titulo' },
      { text: 'Sigla', align: 'left', value: 'sigla' },
      { text: 'Data de início', align: 'left', value: 'dataInicio' },
      { text: 'Prazo (meses)', align: 'left', value: 'prazoMeses' },
      { text: 'Situação', align: 'left', value: 'situacao.descricao' },
      { text: 'Tipo de participação', align: 'left', value: 'tipoParticipacaoUsuarioLogado.descricao' },
      { text: 'Opções', align: 'left', value: 'opcoes' }
    ],
    listaMeusProjetosPesquisa: []
  }),
  props: ['items'],
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING']),

    // Abre o cadastro do projeto de pesquisa.
    toAbrirCadastroProjetoPesquisa: function (idProjetoPesquisa) {
      this.$router.push({ name: 'ProjetoPesquisaInformacoesBasicas', params: {idProjetoPesquisa: idProjetoPesquisa} })
    }
  },
  mounted () {
    // Carrega os projetos de pesquisa dos quais o usuário logado faz parte.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando meus projetos de pesquisa...' })
    projetos.getMeusProjetosPesquisa()
    .then(response => {
      this.listaMeusProjetosPesquisa = response.data.slice()
    })
    .catch(error => {
      console.log('Erro ao mandar o request' + error)
    })
    .finally(() => {
      this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando meus projetos de pesquisa...' })
    })
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'c-tooltip-btn': TootipButton
  }
}
</script>

<style lang="css" slot-scoped>
</style>



// WEBPACK FOOTER //
// meus-projetos-pesquisa.vue?63004d00